import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  Hidden,
  Box,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import AppIcons from "../utils/appIcons";
import Strings from "../utils/stringUtil";
import styles from "../assets/styles/main.module.css";
import Routes from "../utils/routesUtil";
import { ArrowBack } from "@mui/icons-material";
import { isMobile } from "../utils/responsiveUtil";
import AppColors from "../utils/appColors";

function Navbar({ isBranchRedirection, isBusinessLoanPage }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const pathname = useLocation()?.pathname;
  const [isScrolled, setScrolled] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const closeDrawer = () => {
    setMobileOpen(false);
  };

  useEffect(() => {
    if (isBusinessLoanPage) {
      const handleScroll = () => {
        if (window.scrollY > 100) {
          // Adjust the scroll threshold as needed
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [isBusinessLoanPage]);

  const drawer = (
    <Box display="grid" p={2} className={styles.mobileNavLink}>
      <Link
        to={Routes.FINANCIAL_PRODUCTS}
        onClick={closeDrawer}
        className={
          pathname === Routes.FINANCIAL_PRODUCTS
            ? styles.activeNavbarLink
            : styles.navbarLink
        }
      >
        Products
      </Link>

      <Link
        to={Routes.BLOG}
        className={styles.navbarLink}
        target="_blank"
        rel="noopener noreferrer"
        onClick={closeDrawer}
      >
        Blog
      </Link>
      <Link
        to={Routes.MAHILA_LOAN}
        className={
          pathname === Routes.MAHILA_LOAN
            ? styles.activeNavbarLink
            : styles.navbarLink
        }
        onClick={closeDrawer}
      >
        Apply for a loan
      </Link>
    </Box>
  );
  return (
    <div>
      <AppBar
        style={{
          position: isBusinessLoanPage ? "fixed" : "relative",
          zIndex: 4,
          backgroundColor: isBusinessLoanPage ? AppColors.green02 : "white",
          boxShadow:
            isBusinessLoanPage && !isScrolled
              ? "none"
              : "rgba(0, 0, 0, 0.2) 0px -10px 10px 5px",
        }}
      >
        <Toolbar>
          <div className={styles.container}>
            {/* Logo */}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0px",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                {isMobile && window.location.pathname != "/" && (
                  <ArrowBack
                    style={{ color: "black" }}
                    onClick={() => history?.back()}
                  />
                )}

                <Link to={Routes.HOME} className={styles.navbarLink}>
                  <img
                    src={AppIcons.imgLogo}
                    alt={Strings.mahilaMoney}
                    style={{
                      width: "70px",
                      height: "auto",
                      marginTop: "6px",
                    }}
                  />
                </Link>
              </div>

              {/* Menu on the right side for desktop */}
              {!isBranchRedirection && (
                <Hidden mdDown>
                  <div className={styles.flexAlignCenter}>
                    <Link
                      to={Routes.FINANCIAL_PRODUCTS}
                      className={
                        pathname === Routes.FINANCIAL_PRODUCTS
                          ? styles.activeNavbarLink
                          : styles.navbarLink
                      }
                    >
                      Products
                    </Link>

                    <Link
                      to={Routes.BLOG}
                      className={styles.navbarLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Blog
                    </Link>
                    {isBusinessLoanPage && !isMobile ? (
                      <Link
                        to={Routes.CONTACT_US}
                        className={
                          isBusinessLoanPage
                            ? styles.greenNeedHelpBtn
                            : styles.needHelpBtn
                        }
                      >
                        {Strings.needHelp}
                      </Link>
                    ) : (
                      !isMobile &&
                      pathname !== Routes.MAHILA_LOAN && (
                        <Link
                          to={Routes.MAHILA_LOAN}
                          className={styles.applyBtn}
                        >
                          Apply for a loan
                        </Link>
                      )
                    )}
                  </div>
                </Hidden>
              )}
              {isMobile && (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  align-items="center"
                >
                  {isBusinessLoanPage && (
                    <Link
                      to={Routes.CONTACT_US}
                      className={
                        isBusinessLoanPage
                          ? styles.greenNeedHelpBtn
                          : styles.needHelpBtn
                      }
                    >
                      {Strings.needHelp}
                    </Link>
                  )}
                  {/* Menu button for mobile */}
                  {!isBranchRedirection && (
                    <Hidden lgUp>
                      <IconButton
                        edge="end"
                        color="inherit"
                        aria-label="menu"
                        onClick={handleDrawerToggle}
                      >
                        <MenuIcon style={{ color: "black" }} />
                      </IconButton>
                    </Hidden>
                  )}
                </Box>
              )}
            </div>
          </div>
        </Toolbar>
      </AppBar>

      {/* Sidebar for mobile */}
      {!isBranchRedirection && (
        <Hidden lgUp>
          <Drawer
            variant="temporary"
            anchor="right"
            open={mobileOpen}
            onClose={handleDrawerToggle}
          >
            {drawer}
          </Drawer>
        </Hidden>
      )}
    </div>
  );
}

export default Navbar;
